/*
 * Copyright (C) 2009-2025 SonarSource Sàrl
 * All rights reserved
 * mailto:info AT sonarsource DOT com
 */

import { Divider } from '@sonarsource/echoes-react';
import { LinkedIssueStatusFacet } from '~feature-jira/components/LinkedIssueStatusFacet';
import { JIRA_INTEGRATION_ORGANIZATION_UUID, LINKED_TICKET_STATUSES } from '~feature-jira/helpers';
import { useJiraOrganizationBindingQuery } from '~feature-jira/queries';
import { useAvailableFeatures } from '~sq-server-commons/context/available-features/withAvailableFeatures';
import { Feature } from '~sq-server-commons/types/features';

export interface JiraTicketStatusFacetProps {
  facetStats?: Record<string, number>;
  facetStatuses: string[];
  isFacetOpen: boolean;
  isLoading: boolean;
  onFacetToggle: (property: string) => void;
  onFilterChange: (changes: Record<string, Array<(typeof LINKED_TICKET_STATUSES)[number]>>) => void;
}
export function JiraTicketStatusFacet({
  facetStats,
  facetStatuses,
  isFacetOpen,
  isLoading,
  onFilterChange,
  onFacetToggle,
}: Readonly<JiraTicketStatusFacetProps>) {
  const { hasFeature } = useAvailableFeatures();
  const hasJiraIntegrationFeature = hasFeature(Feature.JiraIntegration);

  const { data: organizationBinding } = useJiraOrganizationBindingQuery(
    JIRA_INTEGRATION_ORGANIZATION_UUID,
    {
      enabled: hasJiraIntegrationFeature,
    },
  );

  if (!hasJiraIntegrationFeature || !organizationBinding?.jiraInstanceUrl) {
    return null;
  }

  return (
    <>
      <Divider className="sw-my-2" />

      <LinkedIssueStatusFacet
        fetching={isLoading}
        onChange={onFilterChange}
        onToggle={onFacetToggle}
        open={isFacetOpen}
        stats={facetStats}
        statuses={facetStatuses}
      />
    </>
  );
}
